export const appendClassName = (existing: string | undefined, others: string) =>
  [...(existing?.split(' ') || []), ...others.split(' ')].join(' ').trim();

export const appendClassNames = (...others: (string | undefined | false)[]) =>
  others.filter(item => typeof item === 'string').join(' ');
